export type QuestionType =
  | 'Opinion' |'Discussion' |'Advantages & Disadvantages' |'Problems & Solutions' |'Double Question' |'Direct Question' |'Mixed';

export type Difficulty = 'Foundation' | 'Intermediate' | 'Advanced';

export type ExamType = 'Academic' | 'General Training' | 'Both';

export interface IELTSQuestion {
  id: string;
  prompt: string;
  type: QuestionType;
  topic: string;
  difficulty: Difficulty;
  examType: ExamType;
  taskInstruction: string;
}

export const questionBank: IELTSQuestion[] = [
  {
    id: 'q-001',
    prompt:
      'In many countries, the number of young people who are not in education, employment or training (NEET) is growing. Some people believe that governments should make it compulsory for young people to do community service or vocational training. Others argue that this restricts individual freedom and is counterproductive.',
    type: 'Discussion',
    topic: 'Employment',
    difficulty: 'Advanced',
    examType: 'Both',
    taskInstruction: 'Discuss both views and give your own opinion.',
  },
  {
    id: 'q-002',
    prompt:
      'Some people believe that the best way to reduce crime is to give longer prison sentences. Others, however, believe there are better alternative ways of reducing crime.',
    type: 'Discussion',
    topic: 'Crime',
    difficulty: 'Intermediate',
    examType: 'Both',
    taskInstruction: 'Discuss both views and give your own opinion.',
  },
  {
    id: 'q-003',
    prompt:
      'The rise of e-commerce and online shopping has transformed the way people buy goods and services. While this has brought many benefits to consumers, it has also had significant negative consequences for traditional high-street businesses and town centres.',
    type: 'Advantages & Disadvantages',
    topic: 'Technology',
    difficulty: 'Intermediate',
    examType: 'Both',
    taskInstruction: 'Discuss the advantages and disadvantages of this trend.',
  },
  {
    id: 'q-004',
    prompt:
      'Many cities around the world are facing serious traffic congestion problems. This has a negative impact on both the environment and the quality of life of residents.',
    type: 'Problems & Solutions',
    topic: 'Transportation',
    difficulty: 'Foundation',
    examType: 'Both',
    taskInstruction:
      'What are the main causes of traffic congestion in cities? What measures could be taken to address this problem?',
  },
  {
    id: 'q-005',
    prompt:
      'Some people think that it is more important for children to learn practical life skills at school, such as cooking, financial management, and basic home maintenance, rather than focusing solely on academic subjects.',
    type: 'Opinion',
    topic: 'Education',
    difficulty: 'Foundation',
    examType: 'Both',
    taskInstruction: 'To what extent do you agree or disagree with this statement?',
  },
  {
    id: 'q-006',
    prompt:
      'In some countries, the government is investing heavily in developing artificial intelligence (AI) to replace human workers in many industries. While this increases productivity and economic growth, it also causes widespread unemployment and social inequality.',
    type: 'Advantages & Disadvantages',
    topic: 'Technology',
    difficulty: 'Advanced',
    examType: 'Academic',
    taskInstruction:
      'Do the advantages of this development outweigh the disadvantages?',
  },
  {
    id: 'q-007',
    prompt:
      'International tourism has grown significantly over the past few decades, bringing both economic benefits and cultural challenges to host countries.',
    type: 'Double Question',
    topic: 'Tourism',
    difficulty: 'Intermediate',
    examType: 'Both',
    taskInstruction:
      'What are the economic benefits of tourism for host countries? How can governments manage the negative cultural impact of mass tourism?',
  },
  {
    id: 'q-008',
    prompt:
      'Many governments are introducing stricter regulations on the fast food industry, including taxes on unhealthy food and drinks, restrictions on advertising, and mandatory nutritional labelling.',
    type: 'Opinion',
    topic: 'Health',
    difficulty: 'Intermediate',
    examType: 'Both',
    taskInstruction:
      'Do you think governments should have the right to regulate what people eat and drink? Give reasons for your answer and include any relevant examples from your own knowledge or experience.',
  },
  {
    id: 'q-009',
    prompt:
      'Some experts argue that the widespread use of social media has fundamentally changed the way people communicate, form relationships, and participate in society — mostly for the worse.',
    type: 'Opinion',
    topic: 'Media',
    difficulty: 'Advanced',
    examType: 'Both',
    taskInstruction: 'To what extent do you agree or disagree with this view?',
  },
  {
    id: 'q-010',
    prompt:
      'In many developed countries, the population is ageing rapidly. This demographic shift is placing increasing pressure on healthcare systems, pension funds, and social services.',
    type: 'Problems & Solutions',
    topic: 'Society',
    difficulty: 'Advanced',
    examType: 'Academic',
    taskInstruction:
      'What problems does an ageing population create for society? What solutions can you suggest to deal with these problems?',
  },
  {
    id: 'q-011',
    prompt:
      'Some people believe that animals should not be kept in zoos, as this is cruel and restricts their natural behaviour. Others argue that zoos play a vital role in conservation and education.',
    type: 'Discussion',
    topic: 'Animal Welfare',
    difficulty: 'Foundation',
    examType: 'Both',
    taskInstruction: 'Discuss both views and give your own opinion.',
  },
  {
    id: 'q-012',
    prompt:
      'Governments in many countries spend large amounts of money on space exploration programmes. Critics argue that this money would be better spent solving problems on Earth, such as poverty, disease, and climate change.',
    type: 'Opinion',
    topic: 'Science',
    difficulty: 'Advanced',
    examType: 'Academic',
    taskInstruction: 'To what extent do you agree or disagree with this view?',
  },
  {
    id: 'q-013',
    prompt:
      'The globalisation of culture — through film, music, food, and fashion — is eroding local traditions and making the world culturally homogeneous.',
    type: 'Opinion',
    topic: 'Globalisation',
    difficulty: 'Advanced',
    examType: 'Both',
    taskInstruction: 'To what extent do you agree or disagree with this statement?',
  },
  {
    id: 'q-014',
    prompt:
      'In many parts of the world, children are spending more time indoors using digital devices and less time playing outdoors. This trend has significant consequences for their physical and mental development.',
    type: 'Double Question',
    topic: 'Children',
    difficulty: 'Intermediate',
    examType: 'Both',
    taskInstruction:
      'Why is this trend occurring, and what are its consequences for children? What measures could parents and governments take to address this issue?',
  },
  {
    id: 'q-015',
    prompt:
      'Some employers argue that they should have the right to monitor their employees\' use of the internet, email, and social media during working hours. Others believe this is an invasion of privacy.',
    type: 'Discussion',
    topic: 'Business',
    difficulty: 'Intermediate',
    examType: 'Both',
    taskInstruction: 'Discuss both views and give your own opinion.',
  },
  {
    id: 'q-016',
    prompt:
      'The housing crisis in many major cities has been driven by a combination of population growth, inadequate housing supply, and speculative investment in property.',
    type: 'Problems & Solutions',
    topic: 'Housing',
    difficulty: 'Advanced',
    examType: 'General Training',
    taskInstruction:
      'What are the main causes of the housing crisis in major cities? What measures should governments take to make housing more affordable?',
  },
  {
    id: 'q-017',
    prompt:
      'Some people believe that all university education should be free and funded by the government. Others argue that students should contribute to the cost of their own education.',
    type: 'Discussion',
    topic: 'Education',
    difficulty: 'Foundation',
    examType: 'Both',
    taskInstruction: 'Discuss both views and give your own opinion.',
  },
  {
    id: 'q-018',
    prompt:
      'Climate change is the most significant environmental challenge facing humanity today. Yet despite decades of scientific evidence, international cooperation to address it has been inadequate.',
    type: 'Problems & Solutions',
    topic: 'Environment',
    difficulty: 'Advanced',
    examType: 'Academic',
    taskInstruction:
      'Why has international action on climate change been insufficient? What steps could be taken to achieve more effective global cooperation?',
  },
];

export const questionTypes: QuestionType[] = [
  'Opinion',
  'Discussion',
  'Advantages & Disadvantages',
  'Problems & Solutions',
  'Double Question',
  'Direct Question',
  'Mixed',
];

export const topics = [
  'Education', 'Technology', 'Environment', 'Crime', 'Health',
  'Government', 'Globalisation', 'Business', 'Media', 'Culture',
  'Family', 'Science', 'Employment', 'Transportation', 'Housing',
  'Tourism', 'Society', 'Children', 'Animal Welfare', 'Public Policy',
];

export const difficulties: Difficulty[] = ['Foundation', 'Intermediate', 'Advanced'];